import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";

const state = {
    refundTypes: {...emptyListResponse},
    refundType: null,
}

export const getters = {
    refundTypes: state => state.refundTypes,
    refundType: state => state.refundType,
}

export const mutations = {
    refundTypes(state, refundTypes) {
        state.refundTypes = refundTypes
    },
    refundType(state, refundType) {
        state.refundType = refundType
    },
    deleteRefundType(state, id) {
        state.refundTypes.results = state.refundTypes.results.filter(rt => rt.id !== id)
    },
}

export const actions = service => ({
    async fetchRefundTypeList({commit}, {filters, pagination, sorting}) {
        try {
            const refundTypes = await service.fetchList(filters, pagination, sorting)
            commit('refundTypes', refundTypes)
        } catch (e) {
            if (e instanceof ApiException) {
                commit('refundTypes', emptyListResponse)
            }
            throw e
        }
    },
    async fetchRefundType({commit}, id) {
        const refundType = await service.fetchDetail(id)
        commit('refundType', refundType)
    },
    async createRefundType({commit}, data) {
        const refundType = await service.createRefundType(data)
        commit('refundType', refundType)
    },
    async updateRefundType({commit}, {id, data}) {
        const refundType = await service.updateRefundType(id, data)
        commit('refundType', refundType)
    },
    async deleteRefundType({commit}, id) {
        await service.deleteRefundType(id)
        commit('deleteRefundType', id)
    },
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})
